$(document).ready(function () {
    initFilters(document);
    initFacets(document);
    initFacetForms(document);
    //disable asc sort
    $('.sort-field.desc a').attr('href', '#').click(function(e){
        e.preventDefault();
    })
});

/////////////
// HELPERS //
/////////////

// Retrieve elements by CSS class: http://www.dustindiaz.com/getelementsbyclass
function getElementsByClassName(node, classname) {
    if (node != null) {
        if (node.getElementsByClassName) { // use native implementation if available
            return node.getElementsByClassName(classname);
        } else {

            return (function getElementsByClass(searchClass, node) {
                if (node == null)
                    node = document;
                var classElements = [],
                    els = node.getElementsByTagName("*"),
                    elsLen = els.length,
                    pattern = new RegExp("(^|\\s)" + searchClass + "(\\s|$)"), i, j;

                for (i = 0, j = 0; i < elsLen; i++) {
                    if (pattern.test(els[i].className)) {
                        classElements[j] = els[i];
                        j++;
                    }
                }
                return classElements;
            })(classname, node);
        }
    }
}

// Return true/false if an element has the class in question
function hasClass(ele, cls) {
    if (ele != null && ele.className != null) {
        var regexp = new RegExp('(\\s|^)' + cls + '(\\s|$)');
        return regexp.test(ele.className);
    }
    return false;
}

// Add a new class name if it isn't already present
function addClass(ele, cls) {
    if (ele != null) {
        ele.className = ele.className + ' ' + cls;
    }
}

function setClass(ele, cls) {
    if (ele != null) {
        ele.className = cls;
        if (!this.hasClass(ele, cls)) ele.className += " " + cls;
    }
}

// Remove the specified class name from the element
function removeClass(ele, cls) {
    if (ele != null) {
        if (hasClass(ele, cls)) {
            var reg = new RegExp('(\\s|^)' + cls + '(\\s|$)');
            ele.className = trim(ele.className.replace(reg, ' ').replace(/[ ]{1,}/g, ' '));
        }
    }
}

// Add event cross browser
function addEvent(elem, event, fn) {
    if (elem.addEventListener) {
        elem.addEventListener(event, fn, false);
    } else {
        elem.attachEvent("on" + event, function () {
            // set the this pointer same as addEventListener when fn is called
            return(fn.call(elem, window.event));
        });
    }
}

// Get child nodes
function children(ele) {
    var arr = [];
    if (typeof ele !== 'undefined') {

        var child = ele.firstChild;
        var lastChild = ele.lastChild;

        while (child != lastChild) {
            arr.push(child);
            child = child.nextSibling;
        }

        // push the lastChild onto the array as we haven't yet
        if (typeof ele.childNodes !== 'undefined' && ele.childNodes.length > 0) {
            arr.push(lastChild);
        }
    }

    return arr;
}

// Trim
function trim(string) {
    return string.replace(/^\s*([\S\s]*?)\s*$/, '$1');
}

// Array contains
function arrayContains(array, obj) {
    if (typeOf(array) == 'array') {
        try {
            return array.indexOf(obj) > -1;
        } catch (e) {
            for (var i = 0, length = array.length; i < length; i++) {
                if (array[i] == obj) {
                    return true;
                }
            }
            return false;
        }
    }
    return false;
}

// Equals Ignore Case
function equalsIgnoreCase(str1, str2) {
    if (typeof str1 === 'string' && typeof str2 === 'string') {
        return str1.toLowerCase() === str2.toLowerCase();
    }
    return false;
}

// Type Of
function typeOf(obj) {
    if (typeof(obj) === "object") {
        if (obj === null) {
            return "null";
        }
        if (obj.constructor === ([]).constructor) {
            return "array";
        }
        if (obj.constructor === (new Date()).constructor) {
            return "date";
        }
        if (obj.constructor === (new RegExp()).constructor) {
            return "regex";
        }
        return "object";
    }
    return typeof(obj);
}

// Get Style, http://robertnyman.com/2006/04/24/get-the-rendered-style-of-an-element/
// now using the jQuery method as more reliable
function getStyle(oElm, strCssRule) {
    return $(oElm).css(strCssRule);
}


/////////////
// Filters //
/////////////

function Filters() {
}

// Find all expand arrows (for drilling into hierarchies) within the filterList and add the click event
Filters.prototype.attachExpandEvent = function (filterList) {

    var expandArrows = getElementsByClassName(filterList, 'expand');

    // Go through each expandArrow
    if (typeof expandArrows !== 'undefined') {
        for (var i = 0; i < expandArrows.length; i++) {
            if (expandArrows[i]) {
                addEvent(expandArrows[i], 'click', function () {
                    var li = this.parentNode;

                    // When the expandArrow is clicked, toggle the class on its sibling OL
                    if (hasClass(li, 'expanded')) {
                        removeClass(li, 'expanded');
                    } else {
                        addClass(li, 'expanded');
                    }

                    return false;
                });
            }
        }
    }
};

// Make the 'Show more' / 'Show less' button clickable
Filters.prototype.attachMoreEvent = function (filterList) {
    var self = this;

    // There may be more than one 'Show more' link (due to nested filters); we're only interested in the last one.
    var moreLinkContainers = getElementsByClassName(filterList, 'more-link');

    if (typeof moreLinkContainers !== 'undefined' && moreLinkContainers.length > 0) {
        var lastIndex = (moreLinkContainers.length > 0) ? moreLinkContainers.length - 1 : 0;
        var moreLink = moreLinkContainers[lastIndex].getElementsByTagName('a')[0];

        // Toggle the 'expanded' class on click, and update the link text
        moreLink.onclick = function () {
            if (hasClass(filterList, 'showing-more')) {
                removeClass(filterList, 'showing-more');
                self.updateMoreLink(moreLink);
            } else {
                addClass(filterList, 'showing-more');
                self.updateLessLink(moreLink);
            }
            return false;
        };
    }
};

Filters.prototype.updateMoreLink = function (moreLink) {
    if (moreLink && moreLink.getAttribute('data-show-more-text') != null) {
        moreLink.innerHTML = moreLink.getAttribute("data-show-more-text");
    }
};
Filters.prototype.updateLessLink = function (lessLink) {
    if (lessLink && lessLink.getAttribute('data-show-less-text') != null) {
        lessLink.innerHTML = lessLink.getAttribute("data-show-less-text");
    }
};


////////////
// Facets //
////////////

function Facets() {
    this.facet;
    this.facetName;
    this.facetExpandCollapse;
}

// Make the 'Show more' / 'Show less' button clickable
Facets.prototype.attachExpandCollapseEvent = function (facet) {
    var self = this;
    self.facet = facet;

    if (self.facet) {
        var collapsible = false;

        if (self.facet.className != null) {
            var cssClasses = self.facet.className.split(' ');
            self.facetName = cssClasses[cssClasses.length - 1];
            self.facetExpandCollapse = getElementsByClassName(self.facet, 'facet-title')[0];
            collapsible = hasClass(self.facet, 'collapsible');
        }

        if (collapsible) {
            // Check which facets to show by default
            if (getCookie(self.facetName) == "expanded") {
                self.showFacet();
            } else if (getCookie(self.facetName) == "collapsed" || hasClass(self.facet, 'collapsed-facet')) {
                self.hideFacet();
            } else {
                addClass(self.facet, 'expanded-facet');
            }

            // Add Click Event
            if (typeof self.facetExpandCollapse !== 'undefined' && self.facetExpandCollapse) {
                addEvent(self.facetExpandCollapse, 'click', function () {

                    // When plus/minus icon is clicked, update the class on the LI
                    if (hasClass(self.facet, 'expanded-facet')) {
                        self.hideFacet();
                    } else {
                        self.showFacet();
                    }

                    return false;
                });
            }
        }
    }
};

Facets.prototype.showFacet = function () {
    var self = this;

    if (self.facetExpandCollapse && self.facetExpandCollapse.getAttribute('data-hide-label') != null) {
        self.facetExpandCollapse.innerHTML = self.facetExpandCollapse.getAttribute('data-hide-label');
    }

    removeClass(self.facet, 'collapsed-facet');
    addClass(self.facet, 'expanded-facet');

    setCookie(self.facetName, "expanded", 30);
};

Facets.prototype.hideFacet = function () {
    var self = this;

    if (self.facetExpandCollapse && self.facetExpandCollapse.getAttribute('data-show-label') != null) {
        self.facetExpandCollapse.innerHTML = self.facetExpandCollapse.getAttribute('data-show-label');
    }

    removeClass(self.facet, 'expanded-facet');
    addClass(self.facet, 'collapsed-facet');
    setCookie(self.facetName, "collapsed", 30);
};


/////////////////
// Facet Forms //
/////////////////

function FacetForms() {
    this.facetForm;
    this.renderer;
}

// Make the 'Show more' / 'Show less' button clickable
FacetForms.prototype.resetForm = function (facetForm) {
    facetForm.reset();
};

// Attach change event
FacetForms.prototype.attachChangeEvent = function (facetForm) {
    var self = this;
    self.facetForm = facetForm;
    var container = getElementsByClassName(self.facetForm, 'apply-filters-container');
    self.renderer = (container !== null && typeof container !== 'undefined' && container.length > 0) ? Tempo.prepare(container[0]) : null;

    $(self.facetForm).on('change', function () {
        self.showSubmitButton();
    });
};

// Show Submit Button
FacetForms.prototype.showSubmitButton = function () {
    var self = this;

    var submitButton = getElementsByClassName(self.facetForm, 'submit')[0];
    if (typeof submitButton !== 'undefined' && submitButton) {
        submitButton.style.display = 'block';
    }

    // If needed, we submit the query to the server and only enable the
    // submit button if there are some results.
    if (self.facetForm && self.facetForm.getAttribute('data-check-result-count') != null) {
        var checkResultCount = self.facetForm.getAttribute('data-check-result-count');
    }
    if (checkResultCount === 'true') {

        if (self.facetForm && self.facetForm.getAttribute('data-service-url') != null) {
            var serviceUrl = self.facetForm.getAttribute('data-service-url');
            var query = $(self.facetForm).serialize(); // Using jQuery
            var action = serviceUrl + '?' + query;

            jQuery.ajax({
                url: action,
                type:'GET',
                async: true,
                success: function (data) {
                    var hits = (typeof data !== 'undefined' && data !== '') ? parseInt(data) : 0;
                    var displayData = { hits: hits };
                    if (hits === 0) {
                        submitButton.disabled = true;
                    } else {
                        submitButton.disabled = false;
                    }
                    if (self.renderer !== null) {
                        self.renderer.render(displayData);
                    }
                }
            });
        }
    }
};


////////////////////////
// Initialize Filters //
////////////////////////

function initFilters(elem) {
    var filterLists = getElementsByClassName(elem, 'filter-list');
    if (typeof filterLists !== 'undefined') {
        for (var i = 0; i < filterLists.length; i++) {
            var filter = new Filters();
            filter.attachMoreEvent(filterLists[i]);

            if (hasClass(filterLists[i], 'hierarchical')) {
                filter.attachExpandEvent(filterLists[i]);
            }
        }
    }
}

///////////////////////
// Initialize Facets //
///////////////////////

function initFacets(elem) {
    var facets = getElementsByClassName(elem, 'facet');

    if (typeof facets !== 'undefined') {
        for (var i = 0; i < facets.length; i++) {
            var facet = new Facets();
            facet.attachExpandCollapseEvent(facets[i]);
        }
    }
}

///////////////////////////
// Initialize Facet Form //
///////////////////////////

function initFacetForms(elem) {
    var facetForms = getElementsByClassName(elem, 'filter-list-form');

    if (typeof facetForms !== 'undefined') {
        for (var i = 0; i < facetForms.length; i++) {
            var facetForm = new FacetForms();
            facetForm.resetForm(facetForms[i]);
            facetForm.attachChangeEvent(facetForms[i]);
        }
    }
}


///////////////
// OLD STUFF //
///////////////

function clickableParent(selectors) {
    var selector = selectors.split(", ");
    for (var i = 0; i < selector.length; i++) {
        var s = selector[i];
        jQuery(s + " a").each(function () {
            var url = jQuery(this).attr('href');
            jQuery(this).parents(selector[i]).bind("click", function () {
                location.href = url;
                return false;
            });
        });
    }
}

function setCookie(c_name, value, expiredays) {
    var exdate = new Date();
    exdate.setDate(exdate.getDate() + expiredays);
    document.cookie = c_name + "=" + escape(value) + ((expiredays == null) ? "" : ";expires=" + exdate.toGMTString());
}

function getCookie(c_name) {
    var c_start, c_end;
    if (document.cookie.length > 0) {
        c_start = document.cookie.indexOf(c_name + "=");
        if (c_start != -1) {
            c_start = c_start + c_name.length + 1;
            c_end = document.cookie.indexOf(";", c_start);
            if (c_end == -1) c_end = document.cookie.length;

            return unescape(document.cookie.substring(c_start, c_end));
        }
    }
    return "";
}

/**
 * @deprecated doesn't seem to be used anymore in codebase that I could find
 */

function getWidgetProperty(widget, property) {
    console.warn("Calling deprecated function!");
    var classString = jQuery(widget + ":first").attr('class'); // get all the classes
    var classes = classString.split(' '); // split into individual classes
    for (var i in classes) { // iterate over each
        var cssProperty = classes[i].split('-');
        if (cssProperty[0] == property) { // figure out which is the property we're looking for
            return cssProperty[1]; // return the value
        }
    }
}

var TWIGKIT = function (parameters) {
    /*
     *   Setting all formal parameters (overriding default parameters)
     */
    if (typeof parameters != 'undefined') {
        for (var property in parameters) {
            if (typeof this[property] != 'undefined') {
                this[property] = parameters[property];
            }
        }
    }
};

TWIGKIT.prototype = {

    /*
     *   Create a filter
     */
    createFilter:function (field, queryValue, displayValue, exclude) {
        if (exclude) {
            exclude = '-';
        } else {
            exclude = '';
        }

        if (queryValue == displayValue) {
            return exclude + field + '["' + this.encode(queryValue) + '"]';
        } else {
            return exclude + field + '["' + this.encode(queryValue) + '"]' + '["' + this.encode(displayValue) + '"]';
        }
    },

    createDateFilter:function (field, direction, date, displayValue) {
        if (direction == 'to') {
            return field + '[,' + date + ']' + '["' + this.encode(displayValue) + '"]';
        } else {
            return field + '[' + date + ',]' + '["' + this.encode(displayValue) + '"]';
        }
    },

    createRangeFilter:function (field, from, to, displayValue) {
        if (displayValue) {
            return field + '[' + from + ',' + to + ']["' + this.encode(displayValue) + '"]';
        } else {
            return field + '[' + from + ',' + to + ']';
        }
    },

    addFilter:function (queryString, filter) {
        return queryString + '&f=' + filter;
    },

    parseFilter:function (filterString) {
        var filter = {};
        filter['value'] = {};

        var regex = /(^.*)\["(.*)"\]\["(.*)"\]/;
        var match = regex.exec(filterString);

        filter['field'] = (match !== null) ? match[1] : '';
        filter['value']['actual'] = (match !== null) ? match[2] : '';
        filter['value']['display'] = (match !== null) ? match[3] : '';

        return filter;
    },

    /*
     *   URL Encode
     */
    encode:function (string) {
        string = string.replace(/%/g, '%25');
        string = string.replace('&', '%26');
        string = string.replace('"', '%22');
        string = string.replace('#', '%23');
        string = string.replace('+', '%2B');

        return string;
    }
};

function TwigkitFunctionArray() {
    this.groups = new Array();
    this.funcs = new Array();
}

TwigkitFunctionArray.prototype.add = function (group, f) {
    if (typeof f != "function") {
        f = new Function(f);
    }
    if (typeof this.funcs[group] === 'undefined') {
        this.funcs[group] = new Array();
        this.groups[this.groups.length] = group;
    }
    this.funcs[group][this.funcs[group].length] = f;
};

TwigkitFunctionArray.prototype.executeAll = function () {
    for (var g = 0; g < this.groups.length; g++) {
        var group = this.groups[g];
        this.execute(group);
    }
};

TwigkitFunctionArray.prototype.execute = function (group) {
    for (var i = 0; i < this.funcs[group].length; i++) {
        this.funcs[group][i]();
    }
};

var TwigkitRenderCallbacks = new TwigkitFunctionArray();

function twigkitRenderFinishedCallback(key) {
    TwigkitRenderCallbacks.execute(key);
}

$(document).ready(function () {
    TwigkitRenderCallbacks.executeAll();
});

var _oldShow = jQuery.fn.show;
jQuery.fn.show = function (speed, oldCallback) {
    return jQuery(this).each(function () {
        var obj = $(this);
        var newCallback = function () {
            if (jQuery.isFunction(oldCallback)) {
                oldCallback.apply(obj);
            }

            obj.trigger('afterShow');
        };

        // you can trigger a before show if you want
        obj.trigger('beforeShow');

        // now use the old function to show the element passing the new callback
        _oldShow.apply(obj, [speed, newCallback]);
    });
};


/////////////////////
// INSTANT RESULTS //
/////////////////////

(function(jQuery) {

    jQuery.fn.initializeInstantResults = function(settings) {
        var instantResultsContainer = $(this);
        var input = settings.form.find("input[name=q]");
        var template = Tempo.prepare(instantResultsContainer, {'escape': false});
        var delay;
        var request = null;

        // Keys
        var keys = {
            UP: 38,
            DOWN: 40,
            BACKSPACE: 8,
            RETURN: 13,
            ESC: 27,
            SHIFT: 16,
            CONTROL: 17,
            CMDL: 91,
            CMDR: 93
        };

        // Event
        input.on('keydown',function(event){

            switch (event.keyCode) {
                case keys.UP:
                    return scroll('up',event);

                case keys.DOWN:
                    return scroll('down',event);

                case keys.SHIFT:
                    return false;

                case keys.CONTROL:
                    return false;

                case keys.CMDL:
                    return false;

                case keys.CMDR:
                    return false;

                case keys.RETURN:
                    return goToResult(event);

                case keys.ESC:
                    template.clear();
                    instantResultsContainer.hide();
                    return false;

                default:
                    if (input.val().length > 1) {
                        fetchResults();
                    } else {
                        instantResultsContainer.hide();
                    }
            }
        });

        // Fetch results
        function fetchResults() {
            clearTimeout(delay);
            if (request !== null) {
                request.abort();
            }

            delay = setTimeout(function () {
                var query = input.val();

                var urlForQuery;
                if (settings.query !== null && settings.query.length > 0) {
                    urlForQuery = settings.serviceUrl + "?" + settings.query.replace(/\{\{[A-z0-9]+?\}\}/g, query);
                } else {
                    // If wildcards are enabled, append an asterisk to the query string
                    if (settings.enableWildcard) {
                        query = query + "*";
                    }

                    urlForQuery = settings.serviceUrl + "?q=" + query + "&f=" + settings.filters + '&rpp=5';
                }

                request = jQuery.ajax({
                    url: urlForQuery,
                    success: function (data) {
                        template.clear();

                        if (data.hits.act[1] > 0) {
                            template.render(data);
                            instantResultsContainer.show();
                        } else {
                            instantResultsContainer.hide();
                        }
                    }
                });

            },250);
        }

        // Scroll
        function scroll(direction,event) {
            var instantResults = instantResultsContainer.find("li");
            var selectedResult = instantResults.filter(".selected");

            // Down
            if (direction == 'down') {
                if (selectedResult.length == 0) {
                    instantResults.first().addClass('selected');
                } else {
                    selectedResult.removeClass('selected');
                    selectedResult.next().addClass('selected');
                }
            }

            // Up
            if (direction == 'up') {
                if (selectedResult.length > 0) {
                    selectedResult.removeClass('selected');
                    selectedResult.prev().addClass('selected');
                }
            }

            event.preventDefault();
            return false;
        }

        // Go to the selected result
        function goToResult(event) {
            var instantResults = instantResultsContainer.find("li");
            var selectedResult = instantResults.filter(".selected");

            // No result is selected, so trigger normal form submit
            if (selectedResult.length == 0) {
                form.trigger('submit');

                // A result is selected, so go to its URL
            } else {
                var url = selectedResult.find('a').attr('href');
                window.location = url;
            }

            event.preventDefault();
            return false;
        }

    };
})(jQuery);


function TwigkitInstantResults() {
    jQuery('.instant-results').each(function() {
        var settings = {
            form : jQuery(this).closest('form'),
            serviceUrl : jQuery(this).data('service-url'),
            filters : jQuery(this).data('filters'),
            query : jQuery(this).data('query'),
            enableWildcard : jQuery(this).data('enable-wildcard')
        };
        jQuery(this).initializeInstantResults(settings);
    });
}

TwigkitRenderCallbacks.add("TwigkitInstantResults", TwigkitInstantResults);


var isIE6 = /MSIE 6/i.test(navigator.userAgent);

(function (jQuery) {
    var config;
    var delay;

    /**
     * HTML elements to use in creating suggestions.
     */
    var html = {
        CONTAINER: 'dl',
        SUGGESTION: 'dd',
        LABEL: 'label'
    };

    /**
     * Keycodes for handling keystrokes.
     */
    var keys = {
        UP: 38,
        DOWN: 40,
        DEL: 46,
        BACKSPACE: 8,
        TAB: 9,
        RETURN: 13,
        ESC: 27,
        PAGEUP: 33,
        PAGEDOWN: 34
    };

    /**
     * Creating the plugin.
     *
     * @param settings
     */
    jQuery.fn.addQuerySuggestionService = function (settings, container) {
        config = {
            'serviceUrl': '/twigkit/services/query-suggestion-service/',
            'serviceId': 'static-completions',
            'serviceRemote': 'false',
            'action': '',
            'containerClassName': 'suggestions',
            'selectedClassName': 'selected',
            'ajax': 'false'
        };

        if (settings) {
            jQuery.extend(config, settings);
        }

        this.each(function () {
            attach(this, container, false);
        });

        return this;
    };

    /**
     * Bind the keyhandler to the INPUT elements.
     *
     * @param elem
     */
    function attach(elem, container, escape) {
        var template = (escape === undefined) ?
            Tempo.prepare(container) :
            Tempo.prepare(container, {'escape': escape});
            //console.log(jQuery(elem))
        //container.css('top', jQuery(jQuery(elem)).offset().top + jQuery(elem).outerHeight() + 'px');
        //container.css('left', jQuery(jQuery(elem)).offset().left + 'px');

        jQuery(elem).bind('keydown keyup', function (event) {

            // The INPUT element being targeted
            var input = event.target;

            // If the INPUT loses focus, then hide any suggestion containers after a certain amount of time
            jQuery(input).blur(function (event) { //return;
                // Timeout is to allow for mouse clicks on a suggestion element
                setTimeout(function () {
                    template.clear();
                    container.hide();
                    if (!isIE6) jQuery(input).removeClass('suggesting');
                }, 250);
            });

            // Clearing delay timer
            clearTimeout(delay);

            // Handling keystrokes
            switch (event.keyCode) {
                // Control keys
                case keys.UP:
                    if (event.type == 'keydown') {
                        event.preventDefault();
                        changeSelection(container, keys.UP);
                    }
                    return false;

                case keys.DOWN:
                    if (event.type == 'keydown') {
                        event.preventDefault();
                        changeSelection(container, keys.DOWN);
                    }
                    return false;

                case keys.RETURN:
                    var target = container.find(html.SUGGESTION + '.' + config.selectedClassName);
                    if (event.type == 'keydown' && target.length > 0) {
                        event.preventDefault();
                        takeSelection(target, container);
                        container.remove();
                        if (!isIE6) jQuery(input).removeClass('suggesting');
                        return false;
                    } else {
                        return true;
                    }

                case keys.ESC:
                    if (event.type == 'keydown') {
                        event.preventDefault();
                        template.clear();
                        container.hide();
                        jQuery(input).removeClass('suggesting');
                    }
                    return false;

                // Not a control key, so constructing a Query to the QuerySuggestionService
                default:
                    if (event.type == 'keyup') {
                        if (event.target.value.length > 0) {
                            delay = setTimeout(function () {
                                if (event.target.value.length > 0) {

                                    var url = config.serviceUrl + config.serviceId + '?q=' + encodeURIComponent(event.target.value);

                                    jQuery.ajax({
                                        url: url,
                                        dataType: "jsonp",
                                        success: function (data) {
                                            // Add an HTML element for each suggestion
                                            var groups = eval(data);

                                            var hasSuggestions = false;
                                            for (var i = 0; i < groups.length; i++) {
                                                if (groups[i].values.length > 0) {
                                                    hasSuggestions = true;
                                                    break;
                                                }
                                            }
                                            if (hasSuggestions) {
                                                template.render(groups);

                                                // Show the container if it has elements
                                                if (container.children().length > 0) {
                                                    jQuery(container).find(html.SUGGESTION).on('hover', function (event) {
                                                        jQuery(container).find(html.SUGGESTION).removeClass(config.selectedClassName);
                                                        jQuery(this).toggleClass(config.selectedClassName);
                                                    });

                                                    jQuery(container).find(html.SUGGESTION).on('click', function (event) {
                                                        jQuery(this).addClass(config.selectedClassName);
                                                        takeSelection(this, container);
                                                    });

                                                    container.show();
                                                    if (!isIE6) jQuery(input).addClass('suggesting');
                                                } else {
                                                    container.remove();
                                                    if (!isIE6) jQuery(input).removeClass('suggesting');
                                                }
                                            } else {
                                                template.clear();
                                                container.hide();
                                            }
                                        }
                                    });
                                }
                            }, 350);
                        } else {
                            template.clear();
                            container.hide();
                        }
                    }

                    return true;
            }
        });
    }

    /**
     * Called when the user takes a given suggestion, either via keystroke or on mouse click.
     *
     * @param input
     * @param suggestionList
     */
    function takeSelection(suggestion, suggestionList) {
        jQuery(suggestionList).hide();
        if (!isIE6) jQuery(suggestion).removeClass('suggesting');

//        jQuery(suggestion).val(jQuery(suggestion).find("a").attr('title'));

        var rel = jQuery(suggestion).find('a').attr('rel');
        var cleanRel = rel.replace(/%3Cem%3E/gi, "").replace(/%3C%2Fem%3E/gi, "");
        document.location = cleanRel;
    }

    /**
     * Move between selection elements within the container.
     *
     * @param suggestionList
     * @param direction
     */
    function changeSelection(suggestionList, direction) {
        if (jQuery(suggestionList).find(html.SUGGESTION + '.' + config.selectedClassName).length == 0) {
            // No element is selected
            jQuery(suggestionList).find(html.SUGGESTION + ':' + (direction == keys.DOWN ? 'first' : 'last')).toggleClass(config.selectedClassName);
        } else {
            // A suggestion element is selected
            if (direction == keys.UP && jQuery(suggestionList).find(html.SUGGESTION).first().hasClass(config.selectedClassName)) {
                // If the top element is selected, and user clicks up arrow, then clear selections
                jQuery(suggestionList).find(html.SUGGESTION).first().removeClass(config.selectedClassName);
            } else {
                if (direction == keys.DOWN && jQuery(suggestionList).find(html.SUGGESTION).last().hasClass(config.selectedClassName)) {
                    jQuery(suggestionList).find(html.SUGGESTION).last().removeClass(config.selectedClassName);
                    jQuery(suggestionList).find(html.SUGGESTION).first().toggleClass(config.selectedClassName);
                } else {
                    var elem = jQuery(suggestionList).find(html.SUGGESTION + '.' + config.selectedClassName);
                    elem.removeClass(config.selectedClassName);
                    if (direction == keys.UP) {
                        if (elem.prev(html.SUGGESTION).length == 0) {
                            elem = elem.parent().prev().find(html.SUGGESTION).last().toggleClass(config.selectedClassName);
                        } else {
                            elem.prev(html.SUGGESTION).toggleClass(config.selectedClassName);
                        }
                    } else {
                        if (elem.next(html.SUGGESTION).length == 0) {
                            elem = elem.parent().next().find(html.SUGGESTION).first().toggleClass(config.selectedClassName);
                        } else {
                            elem.next(html.SUGGESTION).toggleClass(config.selectedClassName);
                        }
                    }
                }
            }
        }
    }
})(jQuery);

function TwigkitQuerySuggestionServiceRegistration() {
    jQuery('input.suggest').each(function () {
        var settings = {};
        var form = jQuery(this).closest('form');
        var container = jQuery(form).find('.tempo-suggestions');

        settings['serviceId'] = jQuery(container).attr('data-service-id');
        settings['serviceUrl'] = jQuery(container).attr('data-service-url');

        jQuery(this).addQuerySuggestionService(settings, container);
    });
}

TwigkitRenderCallbacks.add("QuerySuggestion", TwigkitQuerySuggestionServiceRegistration);